/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonModalService } from 'src/app/modules/events/services/common-modal.service';
import { DataServiceServiceProfile } from '../../services/profile-data-service.service';
import { SharingDataService } from 'src/app/shared/service/sharing-data.service';
import { ToastService } from 'src/app/shared/service/toast.service';
import { LoadingSpinnerService } from 'src/app/shared/service/loading-spinner.service';
import { AppConstants } from 'src/app/shared/constants/constants';
import { TranslationService } from 'src/app/shared/service/translation.service';
import { ToastComponent } from "src/app/components/toast/toast.component";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { CommonModalComponent } from "src/app/shared/common-modal/common-modal.component";
@Component({
  selector: 'app-add-car',
  templateUrl: './add-car.component.html',
  styleUrls: ['./add-car.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ToastComponent, ReactiveFormsModule, TranslateModule, CommonModule, CommonModalComponent],
})
export class AddCarComponent implements OnInit, OnDestroy {
  private readonly commonModalService = inject(CommonModalService);
  private readonly formBulder = inject(UntypedFormBuilder);
  private readonly translationService = inject(TranslationService);
  private readonly dataService = inject(DataServiceServiceProfile);
  private readonly sharingData = inject(SharingDataService);
  private readonly toastService = inject(ToastService);
  private readonly loadingSpinnerService = inject(LoadingSpinnerService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);

  @ViewChild("showModalContent") showModalContent: TemplateRef<any> | undefined;
  @Output() public cancelClicked = new EventEmitter<any>();
  @Input() editCarDetails: any
  headerTitle: string = ""
  component: string = "addCarComponent";
  type: string = 'medium-popup'
  car = "assets/images/car.png"
  vinToUppercase: string = ''
  searchVinValue: string = ''
  searchLicenseValue: string = ''
  carDetails: any
  validVin: boolean = false
  errorOccured: boolean = false
  translationData: any
  carDetailsAvailable: boolean = false;
  showToast: boolean = false;
  toastMessage: string = '';
  isSuccess: any;
  toastType: any = 0;
  position: any;
  leftPosition: any;
  showToastDiv: boolean = false
  timer: any

  public buttonNames: any = AppConstants.COMMON_BUTTON_LABELS;

  carDetailsForm = this.formBulder.group({
    vin: ['', Validators.compose(
      [
        Validators.pattern("^[a-zA-Z0-9]+"),
        Validators.required
      ]
    )]
  })
  isHeaderVisible: boolean = true
  showModal: boolean = true
  isCloseModal: boolean = false
  formValid: boolean = false
  loaderVisible: boolean = false
  inValidText: boolean = false
  carAlreadyavailable: boolean = false
  addCarReq: any
  isItInEditCarState: boolean = false

  ngOnInit(): void {
    this.getToastDetails();
    this.commonModalService._modalHeaderTitle.next('BP_PM_NEW_CAR')
    this.commonModalService._modalHeaderIsCloseBtnVisible.next(false)
    this.commonModalService._modalHeaderIsSaveBtnVisible.next(false)
    this.initialiseCarDetailsForEdit();
  }

  public getToastDetails() {
    this.toastService.toastDetails
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((status: any) => {
        this.showToast = false;
        this.toastMessage = status.message;
        this.toastType = status.toastType;
        this.position = status.position;
        this.leftPosition = status.leftPosition;
        this._cdr.markForCheck();
      });
  }

  public initialiseCarDetailsForEdit() {
    if (this.editCarDetails) {
      this.isItInEditCarState = true
      this.carDetailsForm.patchValue({
        vin: this.editCarDetails.vin
      });
      this.carDetailsForm.get('vin')?.disable()
      this.validVin = true
      this.loaderVisible = false
      this.inValidText = false
      this.carDetailsAvailable = true
      this.vinToUppercase = this.editCarDetails.vin
      this.formValid = true
      this.carDetails = {
        carName: this.editCarDetails.carName,
        carImage: this.editCarDetails.carImageUrl,
        carColor: this.editCarDetails.carColor,
        licensePlate: this.editCarDetails.licensePlate
      }
      this.commonModalService._modalHeaderTitle.next('Edit car details')
    }
  }

  searchCarDetails(value: any) {
    this.searchVinValue = value
    this.vinToUppercase = value.toUpperCase()
    if (value.length == 17 && this.carDetailsForm.valid) {
      this.formValid = true
      this.loaderVisible = true
      clearTimeout(this.timer)
      this.timer =
        setTimeout(() => {
          this.checkVin()
        }, 1000)

    } else {
      this.formValid = false
      this.loaderVisible = false
      this.inValidText = false
      this.carDetailsAvailable = false
    }

  }

  cancelPopup() {
    this.showModal = false
    this.isItInEditCarState = false
    this.cancelClicked.emit(true)
  }
  searchLicense(value: any) {
    this.searchLicenseValue = value
  }
  checkVin() {
    this.dataService.getCarDetails(this.vinToUppercase)
      .subscribe({
        next: (value: any) => {
          this.validVin = true
          this.loaderVisible = false
          this.inValidText = false
          this.carDetailsAvailable = true
          this.carDetails = {
            carName: value.carName,
            carImage: value.carImageUrl,
            carColor: value.carColor
          }
          this._cdr.markForCheck();
        },
        error: () => {
          this.loaderVisible = false
          this.carDetailsAvailable = false
          this.validVin = false
          this.errorOccured = true
          this.inValidText = true
          this._cdr.markForCheck();
        }
      });
  }
  addCarToFleet() {
    if (this.searchLicenseValue.length) {
      this.addCarReq = {
        "vin": this.vinToUppercase,
        "licensePlate": this.searchLicenseValue
      }
    } else {
      this.addCarReq = {
        "vin": this.vinToUppercase
      }
    }
    this.loadingSpinnerService.show();
    this.dataService.addCarToFleet(this.addCarReq)
      .subscribe({
        next: (data: any) => {
          if (data) {
            this.sharingData.setCarAddedSuccessfully(true)
            this.showModal = false
            this.sharingData.setCarAdded(true)
            this.cancelClicked.emit(true)
            this.isItInEditCarState = false
            this.loadingSpinnerService.hide()
            this._cdr.markForCheck();
          }
        },
        error: (error) => {
          this.loadingSpinnerService.hide()
          if (error === "Car already present for the user") {
            this.showToast = true
          }
          this._cdr.markForCheck();
        }
      })
  }

  ngOnDestroy(): void {
    this.sharingData.setToasterToBeDisplayed(false);
  }
}
